<template>
    <div class="tab-pane" v-if="isActive" :class="{'active': isActive}" :id="id">
        <slot></slot>
    </div>
</template>
<script type="text/babel">
    export default {
        name: 'ProfileTab',
        props: {
            id: {required: true},
            label: {required: true},
            isActive: {type: Boolean, default: false}
        },
    }
</script>
